import { render, staticRenderFns } from "./beauty-form.vue?vue&type=template&id=3bf07aa0&scoped=true&"
import script from "./beauty-form.vue?vue&type=script&lang=js&"
export * from "./beauty-form.vue?vue&type=script&lang=js&"
import style0 from "./beauty-form.vue?vue&type=style&index=0&id=3bf07aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf07aa0",
  null
  
)

export default component.exports